module.exports = __webpack_public_path__ + "static/img/02.0ee285ec.png";